// extracted by mini-css-extract-plugin
export default {"container":"aboutCard_container__UiN+h","imageContainer":"aboutCard_imageContainer__hOpGl","logo":"aboutCard_logo__k0Yct"};